export enum BranchConditionOperator {
  Equals = 'Equals',
  DoesNotEqual = 'DoesNotEqual',
  GreaterThan = 'GreaterThan',
  LessThan = 'LessThan',
  Contains = 'Contains',
  DoesNotContain = 'DoesNotContain',
}
